export const ApiBaseUrl = process.env.REACT_APP_BASE_URL;
export const DocumentUploadApiBaseUrl =
  process.env.REACT_APP_DOCUMENT_UPLOAD_URL;
export const EncryptedStorageKey =
  process.env.REACT_APP_ENCRYPTED_STORAGE_SECRET_KEY;
export const SignUpInvitesOnly =
  process.env.REACT_APP_SIGN_UP_INVITES_ONLY === 'true';
export const DisplayInactiveProducts =
  process.env.REACT_APP_DISPLAY_INACTIVE_PRODUCTS === 'true';
export const showFirstLoginPopup =
  process.env.REACT_APP_SHOW_FIRST_LOGIN_POPUP === 'true';
